import { DateTime } from 'luxon'
import { MatchState } from '~/utils/constants'

export const CHECKIN_TIME = 5

export const state = () => ({
	upcomingMatch: null,
	shouldCheckin: false,
	showSelectFivePlayersForQueueModal: false,
	showSelectFivePlayersForCheckInModal: false,
})

export const mutations = {
	setUpcomingMatch(state, match) {
		state.upcomingMatch = match
	},
	setShouldCheckin(state, value) {
		state.shouldCheckin = value
	},
	setShowSelectFivePlayersForQueueModal(state, value) {
		state.showSelectFivePlayersForQueueModal = value
	},
	setShowSelectFivePlayersForCheckInModal(state, value) {
		state.showSelectFivePlayersForCheckInModal = value
	},
}

export const actions = {
	async checkForUpcomingMatch({ commit, rootState }) {
		if (rootState.globalCreateWarLoading) {
			return
		}

		// Scope the war check to the event the roster actually belongs to. Mapped
		// (hard-linked) players are pinned to a hidden event (e.g. preseason) whose
		// roster/match live on that event, not the time-based activeEvent. Falling
		// back to activeEvent keeps normal users unchanged (their roster event ===
		// activeEvent).
		const eventId =
			rootState.user.latestRoster?.event?.id || rootState.event.activeEvent.id

		const { data: matches } = await this.$api.matches.matchSeries.getAll({
			'filter[user]': rootState.user.userId,
			'filter[event]': eventId,
			...(rootState.user.latestRoster
				? { 'filter[roster]': rootState.user.latestRoster.id }
				: null),
			'filter[state]': MatchState.UPCOMING,
			sort: 'date',
			'page[size]': 20,
			'page[number]': 1,
		})

		const nextMatch = getNextUpcomingMatch(matches)
		if (
			!nextMatch ||
			nextMatch.timeDiffInMinutes > CHECKIN_TIME ||
			nextMatch.competitors.length <= 1
		) {
			commit('setUpcomingMatch', null)
			commit('setShouldCheckin', false)
			return
		}

		const { data: checkins } = await this.$api.matches.checkins.getByMatchSeriesId(nextMatch.id)
		commit('setUpcomingMatch', nextMatch)

		if (checkins.length === 0) {
			commit('setShouldCheckin', true)
			return
		}

		const myCheckIn =
			checkins.find((c) => c?.user?.id === rootState?.user?.userId) === undefined
		commit('setShouldCheckin', myCheckIn)
	},
}

const sortMatchesByDate = (matches = []) => {
	return [...matches].sort(
		(a, b) =>
			DateTime.fromISO(a.date).diff(DateTime.fromISO(b.date), ['seconds']).toObject().seconds
	)
}

const getFutureMatches = (matches) => {
	return [...matches].filter(
		(m) =>
			DateTime.fromISO(m.date).toUTC().diff(DateTime.utc(), ['seconds']).toObject().seconds >=
			0
	)
}

const getNextUpcomingMatch = (matches = []) => {
	const futureMatches = getFutureMatches(matches)
	const futureMatchesByDate = sortMatchesByDate(futureMatches)

	return futureMatchesByDate.length > 0 ? futureMatchesByDate[0] : undefined
}
